export const HomeClassName = 'home';
export const DateReplacementKey = '{{Date}}';

export const NHSTrustSelectText = 'NHS Trust';
export const NHSFoundationTrustSelectText = 'NHS Foundation Trust';
